import Hint from './Hint'
export default Hint
